<template lang="pug">
.notification.this-week-wrapper
  .this-week
    .weekday(
      v-for="weekday in weekdays"
      :key="weekday.date"
    )
      .box
        span.weekday__date
          span.is-size-5.day {{ weekday.date | date('ddd') }}
          span.date {{ weekday.date | date('MMM D') }}
        .no-events(v-if="weekday.items.length === 0")
            b-icon(icon="calendar-remove" size="is-large")
        .weekday__events(v-else)
          .weekday__event(v-for="item in weekday.items")
            b-tag(
              v-if="item.type === 'service' && item._source.is_visible"
              :type="item._source.is_canceled ? 'is-danger' : ''"
            ) {{ item._source.title }}
            b-tag(v-if="item.type === 'event'" type="is-primary")
              router-link.has-text-weight-semibold(
                :to="{ name: 'event', params: { id: item._source.key } }"
              )
                b-icon(icon="calendar-blank" size="is-small")
                span {{ item._source.title | truncate(18) }}
</template>

<script>
import { HTTP } from '@/utils/http';

export default {
  name: 'this-week',
  created() {
    HTTP.get('/_views/this_week')
      .then(({ data }) => {
        this.weekdays = data.data.weekdays;
      });
  },
  data() {
    return {
      weekdays: [],
    };
  },
};
</script>

<style lang="scss" scoped>
.this-week-wrapper {
  min-height: 140px;
  padding: 1.25rem;
}
.this-week {
  display: flex;
  justify-content: space-between;
  .weekday {
    font-size: 0.875em;
    min-width: 13%;
    .box {
      padding: 0.875rem;
      height: 100%;
      box-shadow: 0 0 6px rgba(0,0,0,0.025);
      border: none;
      .no-events {
        margin: 0.75rem 0;
        text-align: center;
        .icon {
          color: #f3f3f3;
        }
      }
      .weekday__date {
        display: flex;
        justify-content: space-between;
        align-items: center;
        span.day {

        }
        span.date {
          color: $grey-light;
        }
      }
      .weekday__events {
        margin: 0.5rem 0;
        .tag {
          font-weight: 600;
        }
        .tag.is-primary {
          a {
            text-decoration: none;
          }
        }
        .weekday__event + .weekday__event {
          margin-top: 0.4rem;
        }
      }
    }
  }
}
@media (max-width: $tablet) {
  .this-week-wrapper {
    margin-bottom: 2.5rem;
    padding-right: 0;
    padding-left: 0;
  }
  .this-week {
    scroll-snap-type: mandatory;
    overflow-y: scroll;
    -webkit-overflow-scrolling: touch;
    .weekday {
      scroll-snap-align: start;
      min-width: 12rem;
      margin: 0 0 0 1.25rem;
      & + .weekday {
        margin-left: 1rem;
      }
    }
  }
}
</style>
